import { LightningElement, api, wire } from "lwc";

import { getClient } from "@devforce/trailhead-client-api";

import { LabelsAdapter, LabelsAdapterValue } from "common/labelsAdapter";
import { label } from "common/labels";

import { USER_ORGS_ROUTE } from "../orgPicker/constants";
import * as locales from "./locales";
import { BooleanAttr, attrToBool } from "common/helpers";

export default class extends LightningElement {
  @api open: BooleanAttr = false;
  @api unitUid: string | null = null;
  @api isCustomDeOrg: BooleanAttr = false;

  @wire(LabelsAdapter, { locales })
  private labels: LabelsAdapterValue = null!;

  private name: string | null = null;
  private error: string | null = null;
  private isLoaded: boolean = false;
  private isCreating: boolean = false;

  private fromTrailhead = getClient();

  async connectedCallback() {
    await this.getName();
    this.isLoaded = true;
  }

  private get placeholder() {
    return !this.isLoaded ? this.labels.loading : null;
  }

  private get isNameInputDisabled(): boolean {
    return !this.isLoaded || this.isCreating;
  }

  private get isSubmitDisabled(): boolean {
    return this.isNameInputDisabled || !!this.error;
  }

  private async getName() {
    try {
      const user_orgs_route = attrToBool(this.isCustomDeOrg)
        ? `${USER_ORGS_ROUTE}/random_name?unit_uid=${this.unitUid}`
        : `${USER_ORGS_ROUTE}/random_name`;
      const { data } = await this.fromTrailhead.get<{ data: string }>(
        user_orgs_route
      );
      this.name = data;
    } catch (error) {
      this.name = label("defaultPlaygroundName");
    }
  }

  private handleNameChange(e: { detail: string }) {
    this.name = e.detail.trim();
    this.validateOrgName(this.name);
  }

  private validateOrgName(name: string | null): boolean {
    if (!name || !name.length) {
      return !(this.error = this.labels.requiredError);
    }

    if (name.length > 400) {
      return !(this.error = this.labels.tooLongError);
    }

    return !(this.error = null);
  }

  private handleSubmit() {
    this.isCreating = true;
    this.dispatchEvent(
      new CustomEvent("submit", { detail: { name: this.name } })
    );
  }

  private handleRequestClose() {
    this.dispatchEvent(new CustomEvent("requestclose"));
    this.isCreating = false;
  }
}
